export default __webpack_public_path__ + "assets/images/639926e24c5782ac1977dd6b9732b7dc.png";